import { Tooltip, Typography } from "antd";
import moment from "moment";
import React from "react";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
import { STATUS_DOCUMENT } from "store/string";
import { useResponsive } from "hook/useResponsive";
import logo from "config/img/logo.png";
import "./card_document.css";

const CardDocument = ({ data }) => {
  // -------------------------- VAR -----------------------------
  const { mobile } = useResponsive();
  const size = 90;
  const title = data?.name || "";
  const id = data?.id;
  const locked = false;
  const icon = STATUS_DOCUMENT?.find((s) => s?.value === locked)?.icon;
  const label = STATUS_DOCUMENT?.find((s) => s?.value === locked)?.label;
  const createAt = data?.createAt;
  const labelCreate = moment(createAt?.toDate()).format("DD/MM/YYYY HH:mm:ss");
  const labelTime = mobile ? labelCreate : `${labelCreate}`;

  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <a href={`/bailiff/${id}`} className="card-document">
      <div className="card-document-feature flex items-center justify-center">
        <img style={{ width: size, height: size }} src={logo} alt="logo" />
      </div>
      <div className="card-document-info">
        <Typography.Text
          ellipsis={{ rows: 1 }}
          style={{ fontSize: 16, fontWeight: 500, color: "black" }}
        >
          {title}
        </Typography.Text>
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <div style={{ flex: 0.9 }}>
            <div>
              <Typography.Text
                style={{ width: 100, fontSize: 10, fontStyle: "italic" }}
                ellipsis={{ rows: 1 }}
                type="secondary"
              >
                {labelTime}
              </Typography.Text>
            </div>
          </div>
          <div style={{ flex: 0.1 }}>
            <Tooltip title={label}>{icon}</Tooltip>
          </div>
        </div>
      </div>
    </a>
  );
};
export default CardDocument;
